import apiClient from "./apiClient";

// get service projects
export const getServiceProjects = async (service_id: number) => {
    try {
        const response = await apiClient.get(`/api/sidebar-service-project-list/${service_id}`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching projects data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};